import { createContext } from 'react';
import { ClientProtectedFragment } from 'api';

export const ProtectedClientContext = createContext<ClientProtectedFragment>(null);
